import { trackPageAction } from '@atc/syndicated-logging';

// Ensure we only track the first initialization
let hasTrackedConfig = false;

/**
 * Tracks UDS config time using Performance API
 * Measures from 'uds-config-start' mark to 'uds-config-complete' mark
 * @param {string} ecommerce
 * @param {string} vin
 * @param {string|number} listingId
 */
const trackUDSConfigTime = (ecommerce, vin, listingId) => {
    if (hasTrackedConfig) {
        return;
    }

    // Set flag immediately to prevent race conditions
    hasTrackedConfig = true;

    try {
        if (performance?.mark && performance?.measure) {
            const initMarks = performance.getEntriesByName('uds-initialization', 'mark');
            const configInitTime = initMarks.length > 0 ? initMarks[0].startTime : null;
            const endTime = performance.now();

            performance.mark('uds-config-complete');
            performance.measure('uds-config-time', 'uds-initialization', 'uds-config-complete');

            const measures = performance.getEntriesByName('uds-config-time', 'measure');
            if (measures.length > 0) {
                const timeDifference = Math.round(measures[0].duration);

                const attributes = {
                    tenant: ecommerce,
                    component: 'UnifiedDealStarter',
                    message: 'To measure UDS Config Time',
                    url: window.location.href,
                    completeTime: endTime,
                    duration: timeDifference,
                    vin,
                    listingId,
                };

                if (configInitTime !== null) {
                    attributes.startTime = configInitTime;
                }

                trackPageAction('UDSConfigEvent', attributes);

                performance.clearMarks('uds-config-complete');
                performance.clearMeasures('uds-config-time');
            }
        }
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Failed to measure UDS config time:', error);
        // Reset flag on error so tracking can be retried
        hasTrackedConfig = false;
    }
};

export default trackUDSConfigTime;
